import React, { useState } from "react";
import { Box, Typography, IconButton, Grid } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import HomeIcon from "@mui/icons-material/Home";
import { NotoSansJp } from "./TextStyle";
import useMediaQuery from "@mui/material/useMediaQuery";
import DocumentMeta from "react-document-meta";
import { useBranch, Navigate } from "./useBranch";

const faqs = [
  {
    question:
      "休会制度はありますか？（例えば子供が病気や怪我で長期行けなかった場合）",
    answer: "休会制度はございます。",
  },
  {
    question: "兄弟割はありますか？",
    answer: "兄弟での割引制度があります。詳細はお問い合わせください。",
  },
  {
    question: "お休みした場合振替とかできますか？",
    answer: "可能です。別の教室で振替対応いたします。",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const isSmartphone = useMediaQuery("(max-width:767px)");
  const state = useBranch();
  if (state.status === "loading") return null;
  if (state.status === "notfound") return <Navigate to="/" replace />;
  const branch = state.branch;

  const meta = {
    title: `${branch.roomName}｜よくある質問`,
    description: `${branch.roomName}のよくある質問。休会制度・駐車場・兄弟割・振替対応など、入会前によく寄せられるご質問にお答えします。`,
    canonical: `https://tht-group.co.jp/${branch.id}/faq`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: [...branch.top.regionKeywords, "よくある質問", "体操教室"].join(","),
      },
    },
  };

  return (
    <DocumentMeta {...meta}>
      <Box sx={{ width: "100vw" }}>
        <Grid
          container
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ width: "100vw" }}>
            <Grid
              container
              direction="column"
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: "100%", mt: isSmartphone ? "40px" : "100px" }}>
                <Grid
                  container
                  direction="column"
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    p: isSmartphone ? "0 7%" : "0",
                  }}
                >
                  <Typography
                    component="h1"
                    sx={{
                      color: "darkorange", // 明るい黄色
                      fontSize: isSmartphone ? "20px" : "35px",
                      fontWeight: "bold",
                      pt: isSmartphone ? "0" : "50px",
                      mb: isSmartphone ? "10px" : "20px",
                      ...NotoSansJp,
                    }}
                  >
                    {branch.roomName}｜よくある質問
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#333333",
                      mb: "40px",
                    }}
                  >
                    <HomeIcon fontSize="small" />
                    <Typography
                      sx={{ fontSize: isSmartphone ? "14px" : "16px", mx: 1 }}
                    >
                      {">"}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#333333",
                        fontWeight: 500,
                        fontSize: isSmartphone ? "14px" : "16px",
                        ...NotoSansJp,
                      }}
                    >
                      よくある質問
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      mt: isSmartphone ? " 50px" : "120px",
                      mb: isSmartphone ? " 50px" : "120px",
                    }}
                  >
                    <Box
                      sx={{
                        maxWidth: "1000px",
                        mr: "auto",
                        ml: "auto",
                        position: "relative",
                      }}
                    >
                      {faqs.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            mb: 3,
                            pb: 1,
                          }}
                        >
                          {/* 質問 */}
                          <Box
                            onClick={() => toggleIndex(index)}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: 500,
                                color: "#E0B24B",
                                fontSize: isSmartphone ? "16px" : "18px",
                                p: isSmartphone ? "15px" : "20px",
                                ...NotoSansJp,
                              }}
                            >
                              Q. {item.question}
                            </Typography>
                            <IconButton size="large">
                              {openIndex === index ? (
                                <ArrowDropDownIcon
                                  sx={{
                                    color: "#E0B24B",
                                    transform: "rotate(180deg)",
                                  }}
                                />
                              ) : (
                                <ArrowRightIcon sx={{ color: "#E0B24B" }} />
                              )}
                            </IconButton>
                          </Box>

                          {/* 回答 */}
                          <AnimatePresence>
                            {openIndex === index && (
                              <motion.div
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.4 }}
                              >
                                <Typography
                                  sx={{
                                    color: "#333",
                                    fontSize: isSmartphone ? "14px" : "16px",
                                    mt: 2,
                                    ml: 2,
                                    ...NotoSansJp,
                                  }}
                                >
                                  {item.answer}
                                </Typography>
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Box>
    </DocumentMeta>
  );
};

export default Faq;
